export default {
  common: {
    bingWallpaper: 'Bing Wallpaper',
    home: 'Home',
    about: 'About',
    blog: 'Blog',
    refresh: 'Refresh Page',
    loading: 'Loading...',
    year: '',
    preview: 'Preview',
    close: 'Close',
    today: 'Today',
    yesterday: 'Yesterday',
    dayBefore: 'Day before',
    daysAgo: 'days ago',
    monthsAgo: 'months ago',
    yearsAgo: 'years ago',
    unknown: 'Unknown',
    copySuccess: 'Copied to clipboard',
    copyFail: 'Copy failed, please copy manually',
    language: 'Language',
    chinese: '中文',
    english: 'English',
    visitorCount: 'You are the {count}th visitor',
    copyright: 'All images on this site are from Bing Search, for learning and personal use only',
    footerCopyright: 'Copyright © 2022 - {year}',
    openMenu: 'Open menu',
    fatalError: 'Page loading failed, please refresh and try again',
    regionChina: 'China',
    regionGermany: 'Germany',
    regionCanada: 'Canada',
    regionUK: 'United Kingdom',
    regionIndia: 'India',
    regionUS: 'United States',
    regionFrance: 'France',
    regionItaly: 'Italy',
    regionJapan: 'Japan',
    netdiskQuark: 'Quark Drive',
    netdiskAlipan: 'Alipan Drive',
    downloadViaNetdisk: 'Download HD wallpapers',
    use: 'via'
  },
  wallpaper: {
    siteTitle: 'Bing Wallpaper - Microsoft Bing Daily HD Wallpapers Download',
    siteDesc: 'Bing Wallpaper download site, syncing {strong}Microsoft Bing{/strong} official daily wallpapers every day. Browse and download Bing wallpapers from {strong}China, USA, Japan, Germany, UK, France, Italy, Canada, India{/strong} and more. Supports {strong}4K, 1920x1080, 1920x1200, 1366x768{/strong} and other resolutions. Filter by year and {strong}batch download{/strong} all wallpapers. All HD wallpapers are free to download, perfect for desktop and phone backgrounds.',
    regionFilter: 'Region',
    resolutionFilter: 'Resolution',
    yearFilter: 'Year',
    selectRegion: 'Select region',
    selectResolution: 'Select size',
    selectYear: 'Select year',
    yearHint: 'Select a year to batch download all wallpapers from that year',
    currentFilter: 'Current filter',
    totalWallpapers: '{count} wallpapers',
    batchDownload: 'Batch Download',
    downloadingWallpapers: 'Downloading wallpapers...',
    packaging: 'Packaging...',
    downloadSuccess: 'Successfully downloaded {count} wallpapers',
    downloadFailed: 'Batch download failed, please retry',
    noWallpapers: 'No wallpapers available for download',
    noResults: 'No wallpapers found matching the criteria',
    clearFilters: 'Clear filters',
    filterRegion: 'Region',
    filterYear: 'Year',
    filterResolution: 'Size',
    fetchFailed: 'Failed to fetch wallpaper data',
    fetchFailedNetwork: 'Failed to fetch wallpaper data, please check your network',
    unknownError: 'Unknown error',
    yearSuffix: ''
  },
  detail: {
    viewOriginal: 'View Original',
    backHome: 'Back to Home',
    downloadWallpaper: 'Download',
    copyLink: 'Copy Link',
    viewFullscreen: 'Fullscreen View',
    fullscreenTooltip: 'Click the wallpaper image to view in fullscreen',
    imageDescription: 'Description',
    viewSource: 'View Source',
    openOriginal: 'Open Original',
    copyrightInfo: 'Copyright',
    publishDate: 'Date',
    switchResolution: 'Switch Resolution',
    recommended: 'More Wallpapers',
    loadingDetail: 'Loading wallpaper details...',
    loadFailed: 'Load Failed',
    reload: 'Retry',
    loadingImage: 'Loading image...',
    imageLoadFailed: 'Image load failed',
    missingId: 'Missing wallpaper ID parameter',
    notFound: 'Wallpaper not found',
    fetchDetailFailed: 'Failed to fetch wallpaper details',
    networkError: 'Network error, please check your connection and retry',
    resolutionSwitched: 'Resolution switched to {resolution}',
    startDownload: 'Starting wallpaper download',
    linkCopied: 'Image link copied to clipboard',
    setDesktopHint: 'Right-click the image and select "Set as desktop background"',
    alreadyFavorited: 'This wallpaper has already been favourited',
    favoriteSuccess: 'Wallpaper favourited successfully',
    copyFailedManual: 'Copy failed, please copy manually',
    wechatShareHint: 'Please use WeChat to scan and share',
    shareLinkCopied: 'Share link copied',
    sharePrefix: 'Bing Wallpaper: '
  },
  about: {
    title: 'About Bing Wallpaper',
    subtitle: 'A beautiful Bing wallpaper gallery site with rich browsing, filtering, and download features.',
    timeline1Title: 'Improved all pages',
    timeline2Title: 'First version, basic layout completed',
    timeline3Title: 'Fixed pagination display bug',
    timeline4Title: 'Complete Redesign',
    timeline4Item1: '1. Improved list layout for better aesthetics and simpler operation',
    timeline4Item2: '2. Fixed pagination bug (no longer running on a bug!!!)',
    timeline4Item3: '3. Multi-dimensional wallpaper filtering: region, resolution, year, etc.',
    timeline4Item4: '4. One-click batch download of all wallpapers from a filtered year',
    frontendProject: 'Frontend project: ',
    backendProject: 'Backend project: ',
    backendTutorial: 'Backend tutorial: ',
    selfBuildApi: 'Self-hosted Bing API',
    postPara1: 'The backend uses document database {link}MongoDB{/link} for data storage, unlimited CI/CD tool {link2}GitHub Actions{/link2} to fetch daily wallpaper data and store in MongoDB, Python high-performance async framework {link3}FastAPI{/link3} as the backend, and {link4}Vercel{/link4} for serverless request handling. The frontend uses the {link5}Element UI{/link5} framework for rapid development.',
    postPara2: 'When I first discovered Bing wallpapers, I saw many great wallpapers on Bing and wanted an API for my blog background. Later I learned to build my own API. Along the way, I learned a lot: the pymongo library, FastAPI setup, Python modular design; frontend: navigation layout, icon library integration, vue-router usage, axios request wrapping, pagination loading.',
    postPara3: 'There were many challenges too. I searched extensively to find that Bing wallpaper API supports regions, but the China region was force-redirected. Vercel took ages to figure out how to handle both frontend and backend together. FastAPI had many small pitfalls. It took a long time researching and studying others\' designs to complete the Python modular design. I read through {link}Element UI{/link} countless times, encountered many bugs, understood vue-router by following the official examples, and the pagination still had an unsolved bug — PS: that bug cannot be removed, the project runs on it.',
    postPara4: '{strong}AI{/strong} is absolutely amazing!!!',
    postPara5: 'Now, bing-wallpaper has integrated the {link}Twikoo{/link} comment system. Feel free to leave your thoughts!'
  },
  seo: {
    siteName: 'Bing Wallpaper',
    defaultTitle: 'Bing Wallpaper | Daily HD Wallpapers | Download Wallpapers from Around the World',
    defaultDescription: 'Bing Wallpaper download site, providing Microsoft Bing daily HD wallpapers, supporting multi-region, multi-resolution browsing and downloading.',
    homeTitle: 'Bing Wallpaper | Daily HD Wallpapers | Download Wallpapers from Around the World',
    homeDescription: 'Bing Wallpaper download site, providing Microsoft Bing daily HD wallpapers, supporting 9 regions including China, USA, Japan, Germany, UK, France, Italy, Canada, India. Offers 4K, 1920x1080 and other resolutions, with one-click batch download of all yearly wallpapers.',
    regionTitle: 'Regional Bing Wallpapers',
    regionDescription: 'Browse and download regional Bing daily HD wallpapers, supporting China, USA, Japan, Germany, UK, France, Italy, Canada, India and more.',
    aboutTitle: 'About Us',
    aboutDescription: 'Bing Wallpaper site introduction, providing Microsoft Bing daily HD wallpaper downloads, supporting multi-region and multi-resolution browsing and downloading. All images on this site are from Bing Search, for learning and personal use only.',
    detailTitle: 'Wallpaper Details',
    detailDescription: 'Bing Wallpaper detail page, view HD wallpapers and support multiple resolution downloads.',
    regionSeoTitle: '{name} Bing Wallpaper - {name} Daily HD Wallpaper Download',
    regionSeoDesc: '{name} Bing Wallpaper download, providing Microsoft Bing {name} region daily HD wallpapers, supporting 4K, 1920x1080 and other resolutions, free HD desktop wallpaper downloads.',
    regionSeoKeywords: '{name} Bing Wallpaper,{name} wallpaper,Bing Wallpaper,HD wallpaper download',
    detailSeoTitle: '{title} - {region} Bing Wallpaper HD Download',
    detailSeoDesc: '{title}. {copyright} Published on {date}{region}. Bing Wallpaper offers 4K, 1920x1080 and other resolutions for free download.',
    detailSeoKeywords: '{title},{region} Bing Wallpaper,HD wallpaper download,bing wallpaper,{date}',
    detailSeoKeywordsNoRegion: '{title},Bing Wallpaper,HD wallpaper download,bing wallpaper,{date}',
    detailSeoTitleNoRegion: '{title} - Bing Wallpaper HD Download',
    detailSeoFromRegion: ', from {name}',
    siteJsonLdDesc: 'Bing Wallpaper download site, providing Microsoft Bing daily HD wallpapers, supporting multi-region and multi-resolution browsing and downloading.',
    regionJsonLdDesc: '{name} region Bing daily HD wallpaper download, supporting 4K, 1920x1080 and other resolutions.',
    breadcrumbHome: 'Home',
    breadcrumbRegion: '{name} Bing Wallpaper',
    defaultKeywords: 'Bing Wallpaper,daily wallpaper,HD wallpaper download,Microsoft Bing,Bing Wallpaper,HD wallpaper,desktop wallpaper,4K wallpaper,wallpaper download',
    htmlTitle: 'Bing Wallpaper | Daily HD Wallpapers | Download Wallpapers from Around the World',
    htmlDescription: 'Bing Wallpaper download site, providing Microsoft Bing daily HD wallpapers, supporting 9 regions including China, USA, Japan, Germany, UK, France, Italy, Canada, India. Offers 4K, 1920x1080 and other resolutions, with one-click batch download of all yearly wallpapers.',
    htmlKeywords: 'Bing Wallpaper,daily wallpaper,HD wallpaper download,Microsoft Bing,Bing Wallpaper,HD wallpaper,desktop wallpaper,4K wallpaper,wallpaper download,Bing Wallpaper API,wallpaper collection,daily wallpaper',
    htmlH1: 'Bing Wallpaper - Microsoft Bing Daily HD Wallpaper Download',
    htmlP: 'Bing Wallpaper download site, providing Microsoft Bing daily HD wallpapers, supporting 9 regions including China, USA, Japan, Germany, UK, France and more. Supports 4K, 1920x1080 and other resolutions, with one-click batch download of all yearly wallpapers.',
    twitterTitle: 'Bing Wallpaper | Daily HD Wallpapers',
    twitterDesc: 'Microsoft Bing daily HD wallpaper download, supporting multi-region and multi-resolution.'
  }
}



// WEBPACK FOOTER //
// ./src/locale/en-IN.js